import { helper } from '@ember/component/helper';

export const valueOrSlash = (params) =>
  params[0] === 0 ? 0 : params[0] || '/';

export default helper(valueOrSlash);
